/* SLIDE 33 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "shared/components/SearchBar";

const PakingListAttendancePage = () => {
  const navigate = useNavigate();
  const data = [
    {
      userGroup: "근무자",
      userId: "01-002",
      userName: "사마음시장",
      registrationDate: "2024-01-05",
    },
    {
      userGroup: "근무자",
      userId: "01-002",
      userName: "사마음시장",
      registrationDate: "2024-01-05",
    },
    {
      userGroup: "근무자",
      userId: "01-002",
      userName: "사마음시장",
      registrationDate: "2024-01-05",
    },
  ];
  const [selectedOption, setSelectedOption] = useState("사용자정보(01-002)");

  const options = [
    "사용자정보(01-002)",
    "사용자정보(01-001)",
    "사용자정보(01-003)",
  ];

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleRowClick = () => {
    navigate("/schedule_setting");
  };
  return (
    <div className="schedule-management-container pt-4">
      <SearchBar />
      <div className="htContent">
        <div className="table-header">
          <select
            className="table-select"
            value={selectedOption}
            onChange={handleChange}
          >
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div className="data-table">
          <div className="table-labels">
            <span>사용자구분</span>
            <span>사용자ID</span>
            <span>사용자명</span>
            <span>등록일자</span>
          </div>
          {data.map((row, index) => (
            <div className="filter-table" key={index} onClick={handleRowClick}>
              <span>{row.userGroup}</span>
              <span>{row.userId}</span>
              <span>{row.userName}</span>
              <span>{row.registrationDate}</span>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default PakingListAttendancePage;
